/*
 * Function createImage(source) {
 *  let pastedImage = new Image();
 *  pastedImage.onload = function () {
 *      // Теперь у нас есть изображение из буфера
 *  };
 *  pastedImage.src = source;
 * }
 *
 * function checkInput() {
 *  let child = pasteCatcher.childNodes[0];
 *  pasteCatcher.innerHTML = '';
 *  if (child) {
 *      // Если пользователь вставил изображение – создаем изображение
 *      if (child.tagName === 'IMG') {
 *          createImage(child.src);
 *      }
 *  }
 * }
 *
 * function pasteHandler(e) {
 * // Если поддерживается event.clipboardData (Chrome)
 *  if (e.clipboardData) {
 *      // Получаем все содержимое буфера
 *      let items = e.clipboardData.items;
 *      if (items) {
 *          // Находим изображение
 *          for (let i = 0; i < items.length; i++) {
 *              if (items[i].type.indexOf('image') !== -1) {
 *                  // Представляем изображение в виде файла
 *                  let blob = items[i].getAsFile();
 *                  // Создаем временный урл объекта
 *                  let URLObj = window.URL || window.webkitURL;
 *                  let source = URLObj.createObjectURL(blob);
 *                  // Добавляем картинку в DOM
 *                  createImage(source);
 *              }
 *          }
 *      }
 *      // Для Firefox проверяем элемент с атрибутом contenteditable
 *  } else {
 *      setTimeout(checkInput, 1);
 *  }
 * }
 */

export default async function getDataFromClipboard(availableTypes) {
    try {
        const data = await window.navigator.clipboard
            .read();

        for (const dataItem of data) {
            for (const dataType of dataItem.types) {
                if (availableTypes.includes(dataType)) {
                    return await dataItem.getType(dataType);
                }
            }
        }

        throw new Error();
    } catch (error) {
        throw new Error(error);
    }
}
